(function ($) {
  $(document).ready(function () {
    $('a[data-download="pdf"]').on("click", function (event) {
      event.preventDefault();
      window.print();
    });
  });
})(jQuery);
